/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeProfilesBasicSearchResultDto } from '../models';
// @ts-ignore
import type { EmployeeProfilesSearchResultDto } from '../models';
// @ts-ignore
import type { FindEmployeeProfilesSearchRequestDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { SortByEmployeeProfileSearchColumnDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
/**
 * EmployeeProfileSearchApi - axios parameter creator
 * @export
 */
export const EmployeeProfileSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Employee profiles search
         * @param {number} pageSize 
         * @param {number} page 
         * @param {FindEmployeeProfilesSearchRequestDto} findEmployeeProfilesSearchRequestDto Find employee profiles request
         * @param {SortDirectionDto} [sortOrder] 
         * @param {SortByEmployeeProfileSearchColumnDto} [sortBy] 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeProfilesSearch: async (pageSize: number, page: number, findEmployeeProfilesSearchRequestDto: FindEmployeeProfilesSearchRequestDto, sortOrder?: SortDirectionDto, sortBy?: SortByEmployeeProfileSearchColumnDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getEmployeeProfilesSearch', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getEmployeeProfilesSearch', 'page', page)
            // verify required parameter 'findEmployeeProfilesSearchRequestDto' is not null or undefined
            assertParamExists('getEmployeeProfilesSearch', 'findEmployeeProfilesSearchRequestDto', findEmployeeProfilesSearchRequestDto)
            const localVarPath = `/api/v1/employees/search/profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findEmployeeProfilesSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Employee profiles search by text
         * @param {number} pageSize 
         * @param {number} page 
         * @param {LanguageDto} [lang] 
         * @param {string} [fullTextSearch] Full text search query. Words separated by spaces will be searched against firstName, lastName, and externalEmployeeId
         * @param {boolean} [succession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeProfilesSearchByText: async (pageSize: number, page: number, lang?: LanguageDto, fullTextSearch?: string, succession?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getEmployeeProfilesSearchByText', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getEmployeeProfilesSearchByText', 'page', page)
            const localVarPath = `/api/v1/employees/search/profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (fullTextSearch !== undefined) {
                localVarQueryParameter['fullTextSearch'] = fullTextSearch;
            }

            if (succession !== undefined) {
                localVarQueryParameter['succession'] = succession;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeProfileSearchApi - functional programming interface
 * @export
 */
export const EmployeeProfileSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeProfileSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Employee profiles search
         * @param {number} pageSize 
         * @param {number} page 
         * @param {FindEmployeeProfilesSearchRequestDto} findEmployeeProfilesSearchRequestDto Find employee profiles request
         * @param {SortDirectionDto} [sortOrder] 
         * @param {SortByEmployeeProfileSearchColumnDto} [sortBy] 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeProfilesSearch(pageSize: number, page: number, findEmployeeProfilesSearchRequestDto: FindEmployeeProfilesSearchRequestDto, sortOrder?: SortDirectionDto, sortBy?: SortByEmployeeProfileSearchColumnDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeProfilesSearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeProfilesSearch(pageSize, page, findEmployeeProfilesSearchRequestDto, sortOrder, sortBy, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeProfileSearchApi.getEmployeeProfilesSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Employee profiles search by text
         * @param {number} pageSize 
         * @param {number} page 
         * @param {LanguageDto} [lang] 
         * @param {string} [fullTextSearch] Full text search query. Words separated by spaces will be searched against firstName, lastName, and externalEmployeeId
         * @param {boolean} [succession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeProfilesSearchByText(pageSize: number, page: number, lang?: LanguageDto, fullTextSearch?: string, succession?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeProfilesBasicSearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeProfilesSearchByText(pageSize, page, lang, fullTextSearch, succession, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeProfileSearchApi.getEmployeeProfilesSearchByText']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeProfileSearchApi - factory interface
 * @export
 */
export const EmployeeProfileSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeProfileSearchApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Employee profiles search
         * @param {number} pageSize 
         * @param {number} page 
         * @param {FindEmployeeProfilesSearchRequestDto} findEmployeeProfilesSearchRequestDto Find employee profiles request
         * @param {SortDirectionDto} [sortOrder] 
         * @param {SortByEmployeeProfileSearchColumnDto} [sortBy] 
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeProfilesSearch(pageSize: number, page: number, findEmployeeProfilesSearchRequestDto: FindEmployeeProfilesSearchRequestDto, sortOrder?: SortDirectionDto, sortBy?: SortByEmployeeProfileSearchColumnDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeProfilesSearchResultDto> {
            return localVarFp.getEmployeeProfilesSearch(pageSize, page, findEmployeeProfilesSearchRequestDto, sortOrder, sortBy, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Employee profiles search by text
         * @param {number} pageSize 
         * @param {number} page 
         * @param {LanguageDto} [lang] 
         * @param {string} [fullTextSearch] Full text search query. Words separated by spaces will be searched against firstName, lastName, and externalEmployeeId
         * @param {boolean} [succession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeProfilesSearchByText(pageSize: number, page: number, lang?: LanguageDto, fullTextSearch?: string, succession?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeProfilesBasicSearchResultDto> {
            return localVarFp.getEmployeeProfilesSearchByText(pageSize, page, lang, fullTextSearch, succession, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeProfileSearchApi - interface
 * @export
 * @interface EmployeeProfileSearchApi
 */
export interface EmployeeProfileSearchApiInterface {
    /**
     * 
     * @summary Get Employee profiles search
     * @param {number} pageSize 
     * @param {number} page 
     * @param {FindEmployeeProfilesSearchRequestDto} findEmployeeProfilesSearchRequestDto Find employee profiles request
     * @param {SortDirectionDto} [sortOrder] 
     * @param {SortByEmployeeProfileSearchColumnDto} [sortBy] 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeProfileSearchApiInterface
     */
    getEmployeeProfilesSearch(pageSize: number, page: number, findEmployeeProfilesSearchRequestDto: FindEmployeeProfilesSearchRequestDto, sortOrder?: SortDirectionDto, sortBy?: SortByEmployeeProfileSearchColumnDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeProfilesSearchResultDto>;

    /**
     * 
     * @summary Get Employee profiles search by text
     * @param {number} pageSize 
     * @param {number} page 
     * @param {LanguageDto} [lang] 
     * @param {string} [fullTextSearch] Full text search query. Words separated by spaces will be searched against firstName, lastName, and externalEmployeeId
     * @param {boolean} [succession] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeProfileSearchApiInterface
     */
    getEmployeeProfilesSearchByText(pageSize: number, page: number, lang?: LanguageDto, fullTextSearch?: string, succession?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeProfilesBasicSearchResultDto>;

}

/**
 * EmployeeProfileSearchApi - object-oriented interface
 * @export
 * @class EmployeeProfileSearchApi
 * @extends {BaseAPI}
 */
export class EmployeeProfileSearchApi extends BaseAPI implements EmployeeProfileSearchApiInterface {
    /**
     * 
     * @summary Get Employee profiles search
     * @param {number} pageSize 
     * @param {number} page 
     * @param {FindEmployeeProfilesSearchRequestDto} findEmployeeProfilesSearchRequestDto Find employee profiles request
     * @param {SortDirectionDto} [sortOrder] 
     * @param {SortByEmployeeProfileSearchColumnDto} [sortBy] 
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeProfileSearchApi
     */
    public getEmployeeProfilesSearch(pageSize: number, page: number, findEmployeeProfilesSearchRequestDto: FindEmployeeProfilesSearchRequestDto, sortOrder?: SortDirectionDto, sortBy?: SortByEmployeeProfileSearchColumnDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return EmployeeProfileSearchApiFp(this.configuration).getEmployeeProfilesSearch(pageSize, page, findEmployeeProfilesSearchRequestDto, sortOrder, sortBy, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Employee profiles search by text
     * @param {number} pageSize 
     * @param {number} page 
     * @param {LanguageDto} [lang] 
     * @param {string} [fullTextSearch] Full text search query. Words separated by spaces will be searched against firstName, lastName, and externalEmployeeId
     * @param {boolean} [succession] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeProfileSearchApi
     */
    public getEmployeeProfilesSearchByText(pageSize: number, page: number, lang?: LanguageDto, fullTextSearch?: string, succession?: boolean, options?: RawAxiosRequestConfig) {
        return EmployeeProfileSearchApiFp(this.configuration).getEmployeeProfilesSearchByText(pageSize, page, lang, fullTextSearch, succession, options).then((request) => request(this.axios, this.basePath));
    }
}

